import { Breadcrumb, Col, Row, Tabs, Button } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Countries from "./Countries/countries";
import Brand from "./Brand/brand";
import Payment from "./PaymentMode/payment";
import Modifier from "./Modifier/modifier";
import ItemUnit from "./Unit/itemUnit";
import Currency from "./Curency/currency";
import PriceScheme from "./priceScheme/priceScheme";
import CancelBtn from "../UI/CancelButton/CancelBtn";
import { Link } from "react-router-dom";
import Components from "./Components/components";
import PreviousButton from "../UI/PreviousButton/previousbutton";
import Title from "../UI/Title/Title";
import NextButton from "../UI/NextButton/nextbutton";
import Deliveries from "./Delivery/deliveries";

function AddEditReferences() {
  const [t] = useTranslation("common");
  const [key, setKey] = useState("1");
  const [activeTabLabel, setActiveTabLabel] = useState("Countries");

  const onChange = (key: string) => {
    const item = items.find((item) => item.key === key);
    setActiveTabLabel(item?.label || "");
    setKey(key);
  };
  const items = [
    {
      key: "1",
      label: `${t("countries")}`,
      children: <Countries />,
    },
    {
      key: "2",
      label: `${t("item-brands")}`,
      children: <Brand />,
    },
    {
      key: "3",
      label: `${t("item-units")}`,
      children: <ItemUnit />,
    },
    {
      key: "4",
      label: `${t("payment-methods")}`,
      children: <Payment />,
    },
    {
      key: "5",
      label: `${t("currencies")}`,
      children: <Currency />,
    },
    {
      key: "6",
      label: `${t("modifiers")}`,
      children: <Modifier />,
    },
    {
      key: "7",
      label: `${t("price-schemes")}`,
      children: <PriceScheme />,
    },
    {
      key: "8",
      label: `${t("components")}`,
      children: <Components />,
    },
    {
      key: "9",
      label: `${t("delivery")}`,
      children: <Deliveries />,
    }
  ];
  return (
    <>
      <Row gutter={[0, 8]}>
        <Col offset={1}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("references")}</>,
              },
              {
                title: (
                  <span style={{ color: "#1677FF" }}> {activeTabLabel} </span>
                ),
              },
            ]}
          />
        </Col>
        <Row style={{ minHeight: "70vh" }}>
          <Col offset={1} span={22}>
            <Title title="References" />
          </Col>
          <Col offset={1} span={22}>
            <div style={{ height: "650px" }}>
              <Tabs
                className="ant-tab"
                activeKey={key}
                items={items}
                onChange={onChange}
                data-testid="tabs-test"
              />
            </div>
          </Col>
        </Row>
        <Col offset={1} span={4}>
          <CancelBtn data-testid="cancel-button" />
        </Col>
        <Col
          offset={16}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <Col>
            <PreviousButton
              onClick={() =>
                setKey((oldKey) => (parseInt(oldKey) - 1).toString())
              }
              disabled={true}
            />
          </Col>
          {key !== items.length.toString() ? (
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <NextButton
                onClick={() =>
                  setKey((oldKey) => (parseInt(oldKey) + 1).toString())
                }
                disabled={true}
              />
            </Col>
          ) : (
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                type="primary"
                className="btn"
                size="large"
                disabled={true}
                data-testid="add-button"
              >
                {t("save")}
              </Button>
            </Col>
          )}
        </Col>
      </Row>
    </>
  );
}

export default AddEditReferences;
